import { Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { OrganizeTypes } from '../../../model/enums/organize-types';
import { KeyValue } from '@angular/common';
import { CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { DEPOSITO_DATALIST_NAME } from '../../../model/contants/datalists';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UDEU_LOCATION_SIGNATURA_PROP, UDEU_RECORD_TYPE } from '../../../model/contants/deusto';
import { AppStore, SnackbarErrorAction, SnackbarInfoAction, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { NodePaging } from '@alfresco/js-api';
import { LocationValidator } from '../../../validators/location.validator';
import { Reorganize, ReorganizeLocations } from '../../../model/classes/reorganize';
import { TranslationService } from '@alfresco/adf-core';
import { SMTDataListsService } from 'projects/alden-extension/src/lib/services/data-lists.service';
import { RecordService } from '../../../services/record.service';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';

@Component({
  templateUrl: './organize-record.dialog.html',
  styleUrls: ['./organize-record.dialog.scss'],
})
export class OrganizeRecordDialogComponent implements OnInit {
  // Al poner el ngIf es necesario tener la variable
  @ViewChild('originList') originList: CdkDropList | undefined;
  @ViewChild('destinationList') destinationList: CdkDropList | undefined;

  OrganizeTypes: typeof OrganizeTypes = OrganizeTypes;

  depositOptions: KeyValue<string, string>[];
  originInstallationUnitOptions: KeyValue<string, string>[];
  destinationInstallationUnitOptions: KeyValue<string, string>[];

  private _formBuilder = inject(FormBuilder);

  formGroup: FormGroup<any> = this._formBuilder.group({
    originDeposit: ['', [Validators.required]],
    originInstallationUnit: [{value: '', disabled: true}, [Validators.required, Validators.minLength(3), Validators.pattern(/^[0-9]\d*$/)]],
    originRegisters: [[]],
    destinationDeposit: ['', [Validators.required]],
    destinationInstallationUnit: [{value: '', disabled: true}, [Validators.required, Validators.minLength(3), Validators.pattern(/^[0-9]\d*$/), LocationValidator.DestinationInstallationUnitValidator]],
    destinationRegisters: [[]],
  });

  loading: boolean;
  loadingOrigin: boolean;
  loadingDestination: boolean;

  registers: any[];

  allOriginSelected:boolean = false;
    
  isDragging:boolean = false;

  constructor(private dialogRef: MatDialogRef<OrganizeRecordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public organizeType: KeyValue<OrganizeTypes, string>, private recordService: RecordService,
    protected store: Store<AppStore>, private translationService: TranslationService, private smtDataListsService: SMTDataListsService,
    private dialog: MatDialog
  ) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;
    await this.smtDataListsService.getDataListValues(DEPOSITO_DATALIST_NAME).then((res) => this.depositOptions = res);
    this.loading = false;
  }

  /*drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }*/

  drop(event: CdkDragDrop<any[]>) {
    const draggedItem = event.item.data;
    const selectedItems = event.previousContainer.data.filter(item => item.selected);

    const itemsToMove = draggedItem.selected && selectedItems.length > 0 ? selectedItems: [draggedItem];

    if (event.previousContainer !== event.container) {
      const indexes = itemsToMove.map(item => event.previousContainer.data.indexOf(item)).sort((a, b) => b - a);

      indexes.forEach(index => {
        event.previousContainer.data.splice(index, 1);
      });

      itemsToMove.forEach(item => {
        item.selected = false;
        event.container.data.push(item);
      });

    } else {
      
        this.reorderSelectedItems(event.container.data,itemsToMove,event.currentIndex+1);
    }
  }
  
  async getOriginDocuments() {
    const installationUnit = this.formGroup.get('originInstallationUnit').value;
    if (typeof installationUnit === 'string' && installationUnit.length >= 3) {
      this.loadingOrigin = true;
      this.formGroup.get('originRegisters').setValue([]);
      try {
        const deposit = this.formGroup.get('originDeposit').value;
    
        const results: NodePaging = await this.recordService.getLocatedDocuments(deposit.key, installationUnit);
        const documents = results.list?.entries.map((nodeEntry) => { 
          return { 
            uuid: nodeEntry.entry.id, 
            recordName: nodeEntry.entry.path.elements.find((el) => el.nodeType === UDEU_RECORD_TYPE).name.replace('-', '/'),
            signatura: nodeEntry.entry.properties[UDEU_LOCATION_SIGNATURA_PROP]
          }
        });
        const registers = documents ?? [];
        this.formGroup.get('originRegisters').setValue(registers);
        
        this.registers = registers;
      } catch (err) {
        console.error(err);
        this.store.dispatch(new SnackbarWarningAction('No se pudo obtener los expedientes.'));
      } finally {
        this.loadingOrigin = false;
      }
    } else if (installationUnit.length < 3) {
      this.formGroup.get('originRegisters').setValue([]);
    }
  }

  async getDestinationDocuments() {
    const installationUnit = this.formGroup.get('destinationInstallationUnit').value;
    if (typeof installationUnit === 'string' && installationUnit.length >= 3) {
      this.loadingDestination = true;
      this.formGroup.get('destinationRegisters').setValue([]);
      try {
        const deposit = this.formGroup.get('destinationDeposit').value;
        this.formGroup.get('originRegisters').setValue([...this.registers]);

        const results: NodePaging = await this.recordService.getLocatedDocuments(deposit.key, installationUnit);
        const documents = results.list?.entries.map((nodeEntry) => { 
          return { 
            uuid: nodeEntry.entry.id, 
            recordName: nodeEntry.entry.path.elements.find((el) => el.nodeType === UDEU_RECORD_TYPE).name.replace('-', '/'),
            signatura: nodeEntry.entry.properties[UDEU_LOCATION_SIGNATURA_PROP]
          }
        });
        const registers = documents ?? [];
        this.formGroup.get('destinationRegisters').setValue(registers);
      } catch (err) {
        console.error(err);
        this.store.dispatch(new SnackbarWarningAction('No se pudo obtener los expedientes.'));
      } finally {
        this.loadingDestination = false;
      }
    } else if (installationUnit.length < 3) {
      this.formGroup.get('destinationRegisters').setValue([]);
    }
  }

  enableControl(controlName: string, disable?: boolean) {
    disable ? this.formGroup.controls[controlName].disable() : this.formGroup.controls[controlName].enable();
  }

  checkIfEnableDestinationInstallationUnit() {
    const destinationDepositControl = this.formGroup.get('destinationDeposit');
    let destinationDepositValid = destinationDepositControl.valid;

    if(destinationDepositControl.disabled) {
      destinationDepositControl.enable({ emitEvent: false});
      destinationDepositValid = destinationDepositControl.valid;
      destinationDepositControl.disable({ emitEvent: false});
    }
    this.enableControl('destinationInstallationUnit', !this.formGroup.controls['originInstallationUnit'].valid || !destinationDepositValid);
  }

  sendReorganize() {
    const action = this.translationService.instant(this.organizeType.value);
    const actionMessage = this.organizeType.key === OrganizeTypes.REORGANIZE 
    ? this.translationService.instant('DEUSTO.ACTIONS.ORGANIZE.DIALOG.MESSAGE_REORGANIZE') 
    : this.translationService.instant('DEUSTO.ACTIONS.ORGANIZE.DIALOG.MESSAGE_REORGANIZE_AND_MOVE');

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title: 'DEUSTO.ACTIONS.ORGANIZE.DIALOG.TITLE',
        message: this.translationService.instant('DEUSTO.ACTIONS.ORGANIZE.DIALOG.MESSAGE', { action: actionMessage }),
        noLabel: 'DEUSTO.ACTIONS.ORGANIZE.DIALOG.NO_LABEL',
        yesLabel: this.translationService.instant('DEUSTO.ACTIONS.ORGANIZE.DIALOG.YES_LABEL', { action }),
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {   
        const originDeposit: KeyValue<string, string> = this.formGroup.get('originDeposit').value;
        const originInstallationUnit = this.formGroup.get('originInstallationUnit').value;
        const originRegisters = this.formGroup.get('originRegisters').value;
        const origin = new ReorganizeLocations(originDeposit.key, originInstallationUnit, originRegisters?.map(reg => reg.uuid));
    
        const destinationDeposit: KeyValue<string, string> = this.formGroup.get('destinationDeposit').value;
        const destinationInstallationUnit = this.formGroup.get('destinationInstallationUnit').value;
        const destinationRegisters = this.formGroup.get('destinationRegisters').value;
        const destination = new ReorganizeLocations(destinationDeposit.key, destinationInstallationUnit, destinationRegisters?.map(reg => reg.uuid));
    
        const reorganize = new Reorganize(origin, destination);
        this.recordService.reorganizeDocuments(reorganize)
        .then((_res) => { 
          this.dialogRef.close(); 
          this.store.dispatch(new SnackbarInfoAction('La operación ' + this.translationService.instant(this.organizeType.value) +' los registros se ha realizado correctamente.')); 
        })
        .catch((err) => { 
          console.error("ERROR", err);
          this.store.dispatch(new SnackbarErrorAction('No se pudo '+ this.translationService.instant(this.organizeType.value) +' los registros.')); 
        })
      }
    });
  }

  toggleSelection(item: any): void {
    item.selected = !item.selected;
  }

  toggleOriginSelection(item: any): void {
    item.selected = !item.selected;

    const items = this.formGroup.controls['originRegisters'].value;
    this.allOriginSelected = items.length > 0 && items.every(x => x.selected);
  }

  toggleAllOriginSelection(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    this.allOriginSelected = checked;

    this.formGroup.controls['originRegisters'].value.forEach(
      (item: any) => item.selected = checked
    );
  }

  getSelectedOriginRegisters(): any[] {
    return this.formGroup.controls['originRegisters'].value.filter(
      (item: any) => item.selected
    );
  }

  getDragCount(draggedItem: any): number {

    const selectedItems = this.formGroup.controls['originRegisters'].value.filter((item: any) => item.selected);

    return draggedItem.selected && selectedItems.length > 0? selectedItems.length : 1;
  }

  dragStarted() {
    this.isDragging = true;
  }

  dragEnded() {
    this.isDragging = false;
  }

  reorderSelectedItems(list: any[],selectedItems: any[], targetIndex: number): void {
    const remainingItems = list.filter( item => !selectedItems.includes(item) );

    let adjustedIndex = targetIndex;
    adjustedIndex -= list.slice(0, targetIndex).filter(item => selectedItems.includes(item)).length;

    remainingItems.splice(adjustedIndex,0,...selectedItems);

    list.splice(0, list.length, ...remainingItems);
  }
}